import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { PaymentSuccessModalComponent } from '@modules/driver/components/payment-success-modal/payment-success-modal.component';
import { DriverService } from '@core/services/driver.service';
import { autoUnsubWith, Utility } from '../../services/utility.abstract';
import { ToastService } from '../../services/toast.service';
import { DialogControlService } from '../../services/dialog-control.service';
import { BookingFlowService } from '@shared/components/booking-flow/service/booking-flow.service';
import { ParkingService } from '../parking-lot/services/parking.service';
import { SPOT_TYPE_LABEL, USER_ROLES } from '@shared/constant/shared.constant';
import { GroupUserService } from '@core/services/group-user.service';
import { DateTime } from 'luxon';
import { CommonFunctions } from '../../common-functions';
import { ConfirmPayment } from '@core/models/booking.model';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-booking-invoice',
  templateUrl: './booking-invoice.component.html',
  styleUrls: ['./booking-invoice.component.scss']
})
export class BookingInvoiceComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  slotName: string;
  vehicleType: string;
  area: string;
  address: string;
  parkingSlot: string;
  arrivalTime: string;
  departureTime: string;
  vehicleInformation: string;
  hazardousLoad: string;
  duration: string;
  amount: string;
  discount: string;
  taxAndFees: number;
  total: string;
  dailyDuration: number;
  dayDuration: number;
  bookingid: string;
  monthlyCharges: number;
  weekCharges: number;
  dailyCharges: number;
  dayCharges: number;
  isParkAnywhere: boolean;
  bookingDetail: any;
  discountInPercentage: string;
  taxAndFeesInPercentage: number;
  credit: number;
  isChecked: boolean = false;
  totalAmount: number;
  bookingID: string;
  slotUpdateBookingId: string;
  offerData: any;
  parkingLotId: string;
  currentLatitude: number;
  currentLongitude: number;
  selectedVehicleTypeId: string;
  arrivalDate: number;
  departureDate: number;
  truckIcon: string;
  selectedFareCharge: string;
  afterApplyOffer: any;
  invoiceNumber: string;
  confirmAmount: boolean = false;
  role: string;
  status: any;
  slots: any[] = [];
  selectedSlot: string;
  slotId: string;
  arrivalDatetime: string;
  departureDatetime: string;
  updateSlot: boolean = true;
  spotTypeMsg: string = SPOT_TYPE_LABEL;
  userRoles = USER_ROLES;
  isSmallScreen: boolean = false;
  arrivalTimeStamp: any;
  usedCredit: any;

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly driverService: DriverService,
    private readonly dialogControlService: DialogControlService,
    private readonly bookingFlowService: BookingFlowService, 
    public readonly config: DynamicDialogConfig,
    private readonly groupUserService: GroupUserService,
    private readonly toastService: ToastService,
    private readonly parkingService: ParkingService,
    private readonly encryptStorage: EncryptionStorageService
  ) { };

  ngOnInit(): void {
    this.isChecked = false;
    this.role = this.encryptStorage.getItem('roleName');
    this.isParkAnywhere = this.config.data.isParkAnywhere;
    this.parkingLotId = this.config.data.parkingLotId;
    this.updateSlot = this.config?.data?.updateSlot;
    this.currentLatitude = this.config.data.currentLatitude;
    this.currentLongitude = this.config.data.currentLongitude;
    this.selectedVehicleTypeId = this.config.data.selectedVehicleTypeId;
    this.selectedFareCharge = this.config.data.selectedFareCharge;
    this.arrivalDate = this.config.data.arrivalDate;
    this.departureDate = this.config.data.departureDate;
    this.truckIcon = this.config.data.truckIcon;
    this.bookingID = this.config.data.id
    this.fetchBookingSummary(this.config.data.bookingId);
    this.parkingService.getUserCredit()
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.credit = response.credit;
      },
      
    });
  };

  getscreenSize(event: any) {
    this.isSmallScreen = event.isSmallScreen
  };

  fetchBookingSummary(data: string) {
    
    const service = this.role === USER_ROLES.GROUP_USER
    ? this.groupUserService
    : this.driverService;
    const methodName = this.role === USER_ROLES.GROUP_USER
    ? 'getGroupBookingDetailById'
    : 'fetchBookingSummary';
    service[methodName](data)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (res: any) => {
        this.bookingDetail = res;
        this.slotUpdateBookingId = res.id
        this.status = res.status;
        this.arrivalDate = res.arrivalTime;
        this.departureDate = res.departureTime;
        this.parkingLotId = res.parkingLotId;
        this.selectedVehicleTypeId = res.vehicleTypeId;
        this.invoiceNumber = res.invoiceNumber;
        this.slotName = res.parkingSlot;
        this.slotId = res.slotId;
        this.vehicleType = res.vehicleType;
        this.isParkAnywhere = res.isParkAnywhere;
        this.area = res.parkingArea;
        this.address = res.address;
        this.parkingSlot = res.parkingSlot;
        this.arrivalTime = res.arrivalTime;
        this.arrivalTimeStamp = res.arrivalTimeStamp;
        this.departureTime = res.departureTime;
        this.arrivalDatetime = res.arrivalTime
        this.departureDatetime =  res.departureTime
        this.vehicleInformation = res.vehicleInformation;
        this.hazardousLoad = res.hazardousLoad;
        this.duration = res.duration;
        this.dailyDuration = res.dailyDuration;
        this.dayDuration = res.dayDuration;
        this.dayCharges = res.dayCharges;
        this.dailyCharges = res.dailyCharges;
        this.weekCharges = res.weekCharges;
        this.monthlyCharges = res.monthlyCharges;
        this.amount = res.amount;
        this.discount = res.discount;
        this.discountInPercentage = res.discountInPercentage;
        this.taxAndFeesInPercentage = res.taxAndFeesInPercentage;
        this.taxAndFees = res.taxAndFees;
        this.total = res.paidAmount;
        this.usedCredit = res?.usedCredit;
        this.getParkingSlots();
        
        this.shouldDisplayContent();  
      },

    });
  }

  cancelDialog(): void {
    this.ref.close();
  }
  shouldDisplayContent(): boolean {
    return (this.role === this.userRoles.SUPER_ADMIN || this.role === this.userRoles.PARKING_OWNER || this.role === this.userRoles.PARKING_MANAGER) && (this.status === 'In Progress' || this.status === 'Upcoming') &&(!this.isParkAnywhere) && this.updateSlot;
  }

  slotUpdate() {
    
    if (this.slotId != this.selectedSlot) {
      let data = {
        bookingId: this.slotUpdateBookingId,
        newSlotId: this.selectedSlot,
      };

      this.bookingFlowService.updateSlot(data)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (_res: any) => {
          
          this.toastService.showToastMessage('success', 'success', _res.message)
          this.ref.close();

        },
        error: (_error) => {
          this.toastService.showToastMessage('error', 'error', _error.error.message)
        }
      });
    }
    else {
      this.toastService.showToastMessage('error', 'error', 'Select Diffrent Slot')
    }
  }

  getParkingSlots() {
    
    const requestPayload = {
      vehicleType: this.selectedVehicleTypeId,
      arrivalDateTime: CommonFunctions.formatDateToStandard(this.arrivalTime, DateTime, 'LLL dd, yyyy - hh:mm a', 'yyyy-MM-dd HH:mm:ss'),
      departureDateTime: CommonFunctions.formatDateToStandard(this.departureTime, DateTime, 'LLL dd, yyyy - hh:mm a', 'yyyy-MM-dd HH:mm:ss'),
      parkingLotId: this.parkingLotId,
      bookingType: this.bookingDetail?.bookingType,
    };
    this.parkingService.getAvailableSlots(requestPayload)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.slots = response.availableSlots?.map((slot) => ({
          name: slot.name,
          id: slot.id,

        }));

}
    });
  }

UpdateBookingByOffer() {
    let data = {
      bookingId: this.bookingID,
      useCredit: (this.bookingDetail?.usedCredit > 0),
      useOffer: null
    };
  
    this.driverService.UpdateBookingByOffer(data)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (_res: any) => { },
    });
  }

  redirectToCheckout() {
    
    let requestPayload: any;
    const timeZone = Utility.getLocalTimeZone();
    requestPayload = {
      bookingId: this.config.data.id,
      timeZone: timeZone,
      deviceType: 3,
    }
    this.driverService.createPaymentSession(requestPayload)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (_res: any) => {
        
        if (_res.url) {
          window.location.href = _res.url;
        }
      },
      error: (error) => {
        this.toastService.showToastMessage('error', 'Error', error.error.message);
      }
    });
  }

  removeOffer() {
    
    this.offerData = null;
    this.afterApplyOffer = null;
    if (this.offerData === null) {
      this.UpdateBookingByOffer()
      this.confirmAmount = false;
      
      this.fetchBookingSummary(this.config.data.id);
    }
  }
  closeDialog() {
    this.ref.close();
  }

  updatedAmount(updatedAmount: number) {
    let requestPayload: any;
    requestPayload = {
      bookingId: this.config.data.id,
      amount: updatedAmount
    }
    this.parkingService.getUpdatedAmount(requestPayload)
    .pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (_res: any) => {
        this.fetchBookingSummary(this.config.data.id);
      }
    });
  }

  successMessage() {
    
    this.cancelDialog();
    let bookingId = this.encryptStorage.getItem('bookingId')
    let data: ConfirmPayment = {
      cardToken: null,
      bookingId: bookingId
    }
    this.driverService.confirmPayment(data)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe(_res => {
      this.dialogControlService.openDialog(PaymentSuccessModalComponent, {
        width: '30%',
      });
    })
  }
}
